import { createHash } from 'crypto';
import { readFile } from 'fs/promises';

/**
 * Calculate SHA-256 hash of a file
 * @param filePath - Path to the file
 * @returns SHA-256 hash as hex string
 */
export async function calculateFileHash(filePath: string): Promise<string> {
  try {
    const content = await readFile(filePath, 'utf-8');
    return createHash('sha256').update(content).digest('hex');
  } catch (error) {
    throw new Error(`Failed to calculate hash for ${filePath}: ${(error as Error).message}`);
  }
}

/**
 * Calculate SHA-256 hash of a string
 * @param content - String content
 * @returns SHA-256 hash as hex string
 */
export function calculateStringHash(content: string): string {
  return createHash('sha256').update(content).digest('hex');
}

/**
 * Compare two file hashes
 * @param hash1 - First hash
 * @param hash2 - Second hash
 * @returns true if hashes match
 */
export function compareHashes(hash1: string, hash2: string): boolean {
  return hash1 === hash2;
}
